import React, { useEffect, useRef } from 'react';
import { FormikValues } from 'formik';
import { LinearProgress } from '@material-ui/core';
import Card from '../../../common/card/Card';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useUserContext } from '../../../user/User.context';
import { useUpdateFile } from '../Document.hook';
import { BaseDocumentCardProps } from '../Document.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';

export const DocumentInternalIdCard: React.FC<BaseDocumentCardProps> = ({
  document,
  onChange,
  onUpdate,
  onError
}) => {
  const formikRef = useRef<FormikValues>();
  const can = useUserContext().permissions.file;
  const { isFieldDisabled } = useTaskEntityFields(document.task);
  const [{ data: updatedFile, isLoading, error }, updateDocument] =
    useUpdateFile(document.id, document.isFolder);

  useEffect(() => {
    if (updatedFile) {
      onChange?.(updatedFile);
      onUpdate?.();
    }
  }, [updatedFile]);

  useEffect(() => {
    if (error) {
      onError?.(error);
    }
  }, [error]);
  return (
    <Card>
      {isLoading && <LinearProgress />}
      <CardTitle>Internal Document ID</CardTitle>
      <CardContent>
        <InlineFormik
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{
            internalDocumentId:
              document.fileVersion?.internalDocumentId ||
              document.internalDocumentId ||
              ''
          }}
          isSubmitting={isLoading}
          error={error}
          onSubmit={(values: { internalDocumentId: string }) =>
            updateDocument({ ...values })
          }
        >
          <InlineForm>
            <InlineTextField
              name='internalDocumentId'
              placeholder='Enter internal document ID'
              disabled={can.not.update || isFieldDisabled('internalDocumentId')}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};
